var Dropdown                 = require("app/ui/Dropdown"),
    DropdownCaptureSupport   = require("app/ui/DropdownCaptureSupport"),
    IconButton               = require("app/ui/IconButton"),
    RepeaterArrayDataAdapter = require("enyo-ui/RepeaterArrayDataAdapter"),
    SimpleRepeater           = require("enyo-ui/SimpleRepeater"),
    TypeFilterButton         = require("./TypeFilterButton.js"),
    config                   = require("app/config"),
    deepEqual                = require("fast-deep-equal"),
    frameThrottle            = require("enyo-perf/utils").frameThrottle,
    get                      = require("object-path").get,
    icons                    = require("app/theme/icons"),
    kind                     = require("enyo/kind");

require("./TypeFilterDropdown.less");
require("app/theme/IconButton--filter-bar-dropdown.less");

module.exports = kind(/** @lends  app.SearchPage.TypeFilterDropdown.prototype */ {

    /**
     * @private
     */
    name: "app.SearchPage.TypeFilterDropdown",

    /**
     * @private
     */
    kind: Dropdown,

    /**
     * @private
     */
    mixins: [
        DropdownCaptureSupport
    ],

    /**
     * @private
     */
    classes: "app-search-page-type-filter-dropdown",

    /**
     * The kind that will remain visible at all times and toggles the
     * dropdown when tapped.
     *
     * @type  {enyo.Control}
     * @public
     */
    activatorKind: IconButton,

    /**
     * Options for the activator.
     *
     * @type  {Object=}
     * @public
     */
    activatorOptions: {
        theme:         "filter-bar",
        iconAlignment: "right"
    },

    /**
     * Options for the dropdown control
     *
     * @type  {Object=}
     * @public
     */
    dropdownOptions: {
        theme:           "plain",
        showCloseButton: false
    },

    /**
     * Whether the dropdown will list all filters. This affects the label text
     * and will be changed during layout.
     *
     * @public
     */
    listAll: false,

    /**
     * @private
     */
    components: [{
        name:            "repeater",
        kind:            SimpleRepeater,
        classes:         "app-search-page-type-filter-dropdown__repeater",
        dataAdapterKind: RepeaterArrayDataAdapter,

        /**
         * Allow the repeater to draw when the dropdown hasn't opened yet.
         *
         * @returns {boolean} Don't defer drawing
         * @private
         */
        shouldDeferDrawWhenNotAbsoluteShowing: function() {
            return false;
        },

        /**
         * The kind that will be rendered for each item in the dataset.
         *
         * @type  {enyo.Control}
         * @public
         */
        childKind:    TypeFilterButton,
        childOptions: {
            theme: "filter-bar-dropdown"
        }
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @private
     */
    listAllChanged: function() {
        this.updateActivator();

        if (this.get("listAll")) {
            !this.hasClass("list-all") && this.addClass("list-all");
        }
        else {
            while (this.hasClass("list-all")) {
                this.removeClass("list-all");
            }
        }
    },

    /**
     * @protected
     */
    update: function() {
        var state      = this.state || {},
            typeParam  = get(state, "params.type", null),
            types      = get(config, "search.sortedContentTypes", []),
            filterData = [],
            $repeater  = this.$.repeater;

        this.updateActivator();

        // Empty filter, aka just show everything
        filterData.push({
            id:     "all",
            type:   null,
            active: typeParam === null
        });

        types.forEach(function(type) {
            filterData.push({
                id:     type,
                type:   type,
                active: typeParam === type
            });
        });

        // Update repeater only if data changed
        if (!deepEqual(filterData, $repeater.get("data"))) {
            this.$.repeater.set("data", filterData);
        }
    },

    /**
     * Allows us to synchronously update the activator.
     *
     * @private
     */
    updateActivator: function() {
        var i18nService = this.app.$.i18nService,
            $activator  = this.$.activator;

        if (this.listAll) {
            $activator.set("caption", i18nService.getString("app.SearchPage.TypeFilterDropdown.Activator.titleAll"));
        }
        else {
            $activator.set("caption", i18nService.getString("app.SearchPage.TypeFilterDropdown.Activator.titleSome"));
        }
        $activator.set("tooltip", i18nService.getString("app.SearchPage.TypeFilterDropdown.Activator.tooltip"));
        $activator.set("icon", icons["app.SearchPage.TypeFilterDropdown.Activator"]);
    },

    /**
     * @private
     */
    requestHideDropdown: function() {
        this.hideDropdown();
    }

});
